import { UploadIcon } from "@radix-ui/react-icons";
import { IconButton, Tooltip } from "@radix-ui/themes";
import { toast } from "react-hot-toast";
import { SKUSectionChange } from "@/entities/gondola-change-groups";

export type CalibrationData = {
  calibration_id: number;
  calibration_camera_id: number;
  camera_local_id: string;
  gondola_name: string;
  gondola_id: number;
  frame_start_time: string;
  frame_end_time: string;
  sku_section_changes: SKUSectionChange[];
};

export function PasteFromClipboard({
  onSave,
}: {
  onSave: (value: CalibrationData[]) => void;
}) {
  const handlePaste = async () => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      const parsedJson = JSON.parse(clipboardText);
      onSave(parsedJson);
    } catch (error) {
      console.error(error);
      toast.error("Failed to import JSON from clipboard");
    }
  };

  return (
    <div className="flex">
      <Tooltip content="Paste predictions from clipboard in JSON format">
        <IconButton
          onClick={handlePaste}
          size="1"
          variant="soft"
          color="gray"
          mr="4"
        >
          <UploadIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
}
